
import { defineComponent, reactive, toRefs, computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import { useApiGroupList } from "@/hooks/apiManage";
import { addOrModifyApiInfo } from "@/service/api";
import { ElMessage } from "element-plus";
import treeSelect from "../modules/treeSelect.vue";
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      default: {},
    },
    groupTreeData: {
      type: Array,
      default: [],
    },
  },
  emits: ["handleSearch", "close-modal"],
  components: {
    treeSelect,
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const state = reactive({
      formItem: {
        id: "",
        groupId: "",
        title: "",
        url: "",
        version: "1.0",
        method: "",
        shelfState: "1",
        isFrontShow: "1",
        description: "",
        returnExample: "",
        sort: "",
        methodArr: ['GET', 'POST'],
        userId: computed(() => store.state.manageUser.userId),
        userRealname: computed(() => store.state.manageUser.name),
      },
      clickModalClose: false,
      ruleValidate: {
        groupId: [
          {
            required: true,
            message: "请选择接口分组",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入接口路径",
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: "请输入版本号",
            trigger: "blur",
          },
        ],
        methodArr: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请至少选择一项请求方式",
            trigger: "change",
          },
        ],
        isFrontShow: [
          {
            required: true,
            message: "请选择前台是否显示",
            trigger: "change",
          },
        ],
        shelfState: [
          {
            required: true,
            message: "请选择上架状态",
            trigger: "change",
          },
        ],
      },
      //配置树形数据的label和value
      selectProp: {
        value: "id",
        label: "title"
      },
      groupParentId: ''
    });
    const groups = computed(() => store.state.apiManage.groups);
    const ruleForm = ref<any>(null);
    const loading = ref(true);
    const treeData = ref<any>(null); //修改时去除自身的树形数据
    const treeSelect = ref<any>(null); //树形选择器ref
    /**
     * 获取分组列表
     */
    const getApiGroupData = async () => {
      await useApiGroupList(store);
    };
    //点击确定
    function addSubmit() {
      ruleForm.value.validate(async (valid: boolean) => {
        if (valid) {
          const para = Object.assign({}, state.formItem);
          para.method = state.formItem.methodArr.join(",");
          // para.shelfState = Number(para.shelfState);
          const result = await addOrModifyApiInfo(para);
          if (result && parseInt(result.code) === 1) {
            ElMessage({ message: props.title + "成功", type: "success" });
            cancel();
            context.emit("handleSearch");
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          return false;
        }
      });
    }
    //取消审核
    function cancel() {
      ruleForm.value.resetFields();
      state.formItem.id = "";
      state.formItem.groupId = "";
      state.formItem.sort = "";
      state.formItem.methodArr = ['GET', 'POST'];
      state.formItem.title = "";
      state.formItem.url = "";
      state.formItem.version = "1.0";
      state.formItem.method = "";
      state.formItem.shelfState = "1";
      state.formItem.isFrontShow = "1";
      state.formItem.description = "";
      state.formItem.returnExample = "";

      treeSelect.value.clearValue(false);
      context.emit("close-modal");
    }
    //选择分组
    function handleSelect(data: any) {
      state.formItem.groupId = data.id;
    }
    //将树形数据向下递归为一维数组
    function flattenDeep(arr = [], childs = "children"): any {
      return arr.reduce((flat, item) => {
        return flat.concat(
          item,
          item[childs] ? flattenDeep(item[childs], childs) : []
        );
      }, []);
    }

    //根据id获取分组父级id
    function findParentId(data: any, id: string) {
      const tempData = flattenDeep(data);
      const newData = tempData.filter((item: any) => {
        return item.id === id;
      });
      if (newData) {
        state.groupParentId = newData[0].parentId
      }
    }

    function filter(data: any, id: string) {
      const newData = data.filter((item: any) => {
        return item.id !== id;
      });
      newData.forEach((item: any) => {
        if (item.children && item.children.length > 0) {
          item.children = filter(item.children, id);
        }
      });
      return newData;
    }

    watch(
      () => props.dialogVisible,
      async (newVal) => {
        if (newVal) {
          loading.value = true;
          // await getApiGroupData();
          if (props.formData.id != "" && props.formData.id != undefined) {
            state.formItem.id = props.formData.id;
            state.formItem.groupId = props.formData.groupId;
            state.formItem.sort = props.formData.sort;
            state.formItem.methodArr = props.formData.method.split(",");
            state.formItem.title = props.formData.title;
            state.formItem.url = props.formData.url;
            state.formItem.version = props.formData.version;
            state.formItem.method = props.formData.method;
            state.formItem.shelfState = props.formData.shelfState.toString();
            state.formItem.isFrontShow = props.formData.isFrontShow ? "1" : "0";
            state.formItem.description = props.formData.description;
            state.formItem.returnExample = props.formData.returnExample;
            findParentId(props.groupTreeData, props.formData.groupId);
            //修改时，父级分组过滤掉自己
            // treeData.value = filter(props.groupTreeData, props.formData.groupId);
          }
          // else {
          //   treeData.value = props.groupTreeData;
          // }

          treeData.value = props.groupTreeData;
          loading.value = false;
        }
      }
    );
    return {
      ...toRefs(state),
      groups,
      treeData,
      ruleForm,
      cancel,
      addSubmit,
      loading,
      handleSelect,
      treeSelect
    };
  },
});
